
export const FETCH_MODALITY_TYPES = 'FETCH_MODALITY_TYPES';
export const FETCH_MODALITY_TYPES_START = "FETCH_MODALITY_TYPES_START";
export const FETCH_MODALITY_TYPES_SUCCESS = 'FETCH_MODALITY_TYPES_SUCCESS';
export const FETCH_MODALITY_TYPES_ERROR = 'FETCH_MODALITY_TYPES_ERROR';

export const getAllModalityTypes = () => {
    return {
        type: FETCH_MODALITY_TYPES,
    };
}